import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, Routes } from 'react-router-dom';

import { InitialProps } from './data';
import { DoneStep } from './DoneStep';
import { StartStep } from './StartStep';
import { TotpVerifyStep } from './TotpVerifyStep';
import { VerifyStep } from './VerifyStep';

import { Modes, SmsDeliveryMethods } from '../../Shared/data';

const Controller: React.FC<InitialProps> = ({ mfaPhoneNumber, mode }) => {
  if (mode === Modes.totp) {
    return (
      <FlowContextProvider>
        <Routes>
          <Route
            path="/verify"
            element={
              <StepWrapper name="verify">
                <TotpVerifyStep />
              </StepWrapper>
            }
          />
          <Route
            path="/done"
            element={
              <StepWrapper name="done">
                <DoneStep />
              </StepWrapper>
            }
          />
        </Routes>
      </FlowContextProvider>
    );
  }
  const initialValues = {
    deliveryMethod: SmsDeliveryMethods.sms,
    mfaPhoneNumber,
  };
  return (
    <FlowContextProvider initialValues={initialValues}>
      <Routes>
        <Route
          path="/start"
          element={
            <StepWrapper name="start">
              <StartStep />
            </StepWrapper>
          }
        />
        <Route
          path="/verify"
          element={
            <StepWrapper name="verify">
              <VerifyStep />
            </StepWrapper>
          }
        />
        <Route
          path="/done"
          element={
            <StepWrapper name="done">
              <DoneStep />
            </StepWrapper>
          }
        />
      </Routes>
    </FlowContextProvider>
  );
};

export default Controller;
